import axios from "axios";
import { BASE_URL } from "../config/index";
import { store } from "../redux/store";

export const ApiCall = (url, method, data = null, headers = {}) => {
	return new Promise((resolve, reject) => {
		axios({
			method,
			url: `${BASE_URL}${url}`,
			data,
			headers: {
				...headers,
			},
		})
			.then(resolve)
			.catch(reject);
	});
};

export const AfterAuthApi = (url, method, data = null, headers = {}) => {
	return new Promise((resolve, reject) => {
		const token =
			store.getState().loginUsers?.loginUser?.data?.data?.jwtTokens
				?.accessToken;
		// console.log("token", token);
		axios({
			method,
			url: `${BASE_URL}${url}`,
			data,
			headers: {
				Authorization: "Bearer " + token,
				...headers,
			},
		})
			.then((res) => {
				resolve(res);
			})
			.catch(reject);
	});
};
